import { FC } from 'react';
import { useTranslation } from 'hooks';

export const OnboardingInformer: FC<{ email: string }> = ({ email }) => {
  const getTranslate = useTranslation();

  return (
    <div className='bg-background-primary p-4'>
      <div className='text-l-bold text-text-primary'>
        {getTranslate('getStarted.onboardingInformer.title')}
      </div>
      <div className='text-text-primary mt-1'>
        {getTranslate('getStarted.onboardingInformer.description', {
          email: (
            <a href={`mailto:${email}`} className='text-brand-main'>
              {email}
            </a>
          ),
        })}
      </div>
    </div>
  );
};
